export default __webpack_public_path__ + "static/media/patches.7fc4091b.png";